import { DISABLED_BUTTON_SUBMIT } from "App/constants";
import {
  InputReactDatepicker,
  MasterButton,
  Modal,
  TableAction,
} from "App/Component/ui";
import { Grid, TableRow } from "@material-ui/core";
import React, { useState } from "react";
import { useDatatables } from "App/hooks";
import { TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { getTriage } from ".";
import { defaultButtonSearch } from "../../KunjunganRawatJalan/ui/Modal/ModalKunjunganBaru";
import {
  defaultDateDisplay,
  defaultToastError,
  isNull,
  toUTCFormat,
  today,
} from "App/utils/helpers";
import { FreezeTableClient } from "components/organism";
import moment from "moment";

const ModalTriage = ({
  setShowModal,
  formData,
  setFormData,
  rowsTriage,
  setRowsTriage,
}) => {
  const [disabled, setDisabled] = useState(defaultButtonSearch);

  const [filterTriage, setFilterTriage] = useState({
    from_date: today(true),
    to_date: today(true),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isNull(filterTriage.from_date) && !isNull(filterTriage.to_date)) {
      setDisabled(DISABLED_BUTTON_SUBMIT);
      const res = await getTriage(filterTriage.from_date, filterTriage.to_date);
      if (res.state) {
        setRowsTriage(res.data);
        setDisabled(defaultButtonSearch);
      } else {
        setDisabled(defaultButtonSearch);
        defaultToastError(res?.message);
      }
    }
  };

  return (
    <Modal title={`Triage`} width="75%" show={setShowModal}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={6}>
            <InputReactDatepicker
              selected={filterTriage.from_date}
              label="TANGGAL MULAI"
              handleChangeToday={(e) =>
                setFilterTriage({
                  ...filterTriage,
                  from_date: e,
                })
              }
              onChange={(e) =>
                setFilterTriage({
                  ...filterTriage,
                  from_date: e,
                })
              }
            />
          </Grid>

          <Grid item sm={6}>
            <InputReactDatepicker
              selected={filterTriage.to_date}
              label="TANGGAL SELESAI"
              handleChangeToday={(e) =>
                setFilterTriage({
                  ...filterTriage,
                  to_date: e,
                })
              }
              onChange={(e) =>
                setFilterTriage({
                  ...filterTriage,
                  to_date: e,
                })
              }
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            size="md"
          />
        </Grid>
      </form>
      <div className="mt-2">
        <TableListTriage
          rows={rowsTriage}
          formData={formData}
          setFormData={setFormData}
          setShowModal={setShowModal}
        />
      </div>
    </Modal>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "nama_pasien",
    disablePadding: true,
    label: "NAMA PASIEN",
    sort: false,
    align: "left",
    minWidth: "200px",
  },
  {
    id: "status_assesmen",
    disablePadding: true,
    label: "STATUS ASESMEN",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "emergency_ats",
    disablePadding: true,
    label: "STATUS EMERGENCY ATS",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "emergency_pmk",
    disablePadding: true,
    label: "STATUS EMERGENCY PMK 47",
    sort: false,
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal_lahir",
    disablePadding: true,
    label: "TANGGAL LAHIR",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "nik",
    disablePadding: true,
    label: "NIK",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal_masuk",
    disablePadding: true,
    label: "TANGGAL MASUK",
    sort: false,
    align: "left",
    minWidth: "100px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

const TableListTriage = ({ rows, formData, setFormData, setShowModal }) => {
  const {
    page,
    setPage,
    setRowsPerPage,
    order,
    orderBy,
    length,
    data,
    handleRequestSort,
    rowsPerPage,
    setQ,
  } = useDatatables({
    rows: rows,
    orderByDefault: "triage_id",
    orderByRow: ["triage_id", "nama_pasien"],
  });

  const handleClickSelect = (row) => {
    console.log(
      "row.asesmen_triage.toLowerCase()",
      row.asesmen_triage.toLowerCase()
    );
    if (row.asesmen_triage.toLowerCase() === "sudah asesmen") {
      setFormData({
        ...formData,
        id_triage: row?.triage_id,
        label_triage: row?.nama_pasien,
        doctor_id: row.dokter_id,
        doctor_name: row.nama_dokter,
      });
      setShowModal(false);
    } else {
      defaultToastError("Triage tidak bisa dipilih karena belum diasesmen.");
    }
  };

  return (
    <>
      <FreezeTableClient
        title="Daftar Triage"
        setQ={setQ}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        maxHeight="250px"
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow hover tabIndex={-1} key={row.name}>
                <TableCell scope="row" padding="none" align="center">
                  {index + 1}
                </TableCell>

                <TableCell scope="row" width="5%" padding="none" align="center">
                  <TableAction
                    isDelete={false}
                    isUpdate={false}
                    isSelect={true}
                    clickSelect={() => handleClickSelect(row)}
                  />
                </TableCell>
                <TableCell>{row?.nama_pasien}</TableCell>
                <TableCell>{row?.asesmen_triage}</TableCell>
                <TableCell>{row?.emergency_ats}</TableCell>
                <TableCell>{row?.emergency_pmk}</TableCell>
                <TableCell>
                  {defaultDateDisplay(row?.tanggal_lahir, false)}
                </TableCell>
                <TableCell>{row?.nik}</TableCell>
                <TableCell>
                  {defaultDateDisplay(row?.tanggal_masuk, false)}
                </TableCell>
                <TableCell>{defaultDateDisplay(row?.inserted_date)}</TableCell>
                <TableCell>{row?.inserted_user}</TableCell>
                <TableCell>{defaultDateDisplay(row?.updated_date)}</TableCell>
                <TableCell>{row?.updated_user}</TableCell>
              </TableRow>
            );
          })}
      </FreezeTableClient>
    </>
  );
};

export default ModalTriage;
